module.exports = __webpack_public_path__ + "media/images/summit-5-01fab8b25f398cd01af7254610481875.jpg";